<div class="landing">
  <span>Please need to authenticate to access license module</span>
</div>